import { IconButton, Tooltip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import Gruppo from "../../../interfaces/gruppo";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { keyframes } from "@emotion/react";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import axios from "axios";
import BluAsyncDialog from "../../../UI/BluAsyncDialog";
import createFile from "../../../api/file/createFile";

const columnsHandler = (onFileBig: () => void) => {
  const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

  return [
    {
      field: "id",
      headerName: "",
      width: 70,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      hide: true,
    },
    {
      field: "descrizione",
      headerName: "Descrizione",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<string>) => {
        return params.value || "";
      },
    },
    {
      field: "gruppi",
      headerName: "Gruppi",
      flex: 1,
      renderCell: (params) => {
        return (
          <Tooltip
            title={params.row["gruppi"]
              .map((group: Gruppo) => {
                return `${group.descrizione}`;
              })
              .join(" , ")}
          >
            <div>
              {params.row["gruppi"]
                .map((gruppo: any) => {
                  return gruppo.descrizione;
                })
                .join(", ")}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "tipo",
      headerName: "Tipo",
      width: 110,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<string>) => {
        return params.value || "";
      },
    },
    {
      field: "file",
      headerName: "File",
      width: 45,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <input
              accept=".zip"
              type="file"
              id={`inputId-${params.id}`}
              hidden
              onChange={(e: any) => {
                if (e.target.files.length > 0) {
                  const file = e.target.files[0];

                  if (file.size > 20 * 1024 * 1024) {
                    onFileBig();
                    return;
                  }
                  document.getElementById(`file-${params.id}`)!.style.display =
                    "none";
                  document.getElementById(
                    `loading-${params.id}`
                  )!.style.display = "block";

                  const fileReader = new FileReader();
                  try {
                    fileReader.onload = (event: any) => {
                      const fileData = new File(
                        [event.target.result],
                        file.name,
                        { type: file.type }
                      );

                      createFile(fileData, params.row["tipo"])
                        .catch((e) => {
                          BluAsyncDialog({
                            title: "Errore",
                            message:
                              e ||
                              "Si è verificato un errore durante il caricamento del file.",
                            type: "error",
                            confimButton: "Chiudi",
                            hideDeclineButton: true,
                          });
                        })
                        .finally(() => {
                          document.getElementById(
                            `file-${params.id}`
                          )!.style.display = "block";
                          document.getElementById(
                            `loading-${params.id}`
                          )!.style.display = "none";
                        });
                    };
                  } catch (error) {
                    document.getElementById(
                      `file-${params.id}`
                    )!.style.display = "block";
                    document.getElementById(
                      `loading-${params.id}`
                    )!.style.display = "none";
                  }

                  fileReader.readAsArrayBuffer(file);
                }
              }}
            />
            <label htmlFor={`inputId-${params.id}`} id={`file-${params.id}`}>
              <Tooltip
                title={
                  params.row["tipo"].length <= 0
                    ? `Inserire un tipo prima di caricare un file`
                    : params.row["file"].length > 0
                    ? `Aggiorna ${params.row["file"]}`
                    : `Carica file`
                }
              >
                <IconButton color="error" component="span">
                  <CreateNewFolderIcon
                    color={
                      params.row["tipo"].length <= 0 ? "disabled" : "primary"
                    }
                  />
                </IconButton>
              </Tooltip>
            </label>
            <AutorenewIcon
              id={`loading-${params.id}`}
              sx={{
                display: "none",
                animation: `${rotate} 2s linear infinite`,
              }}
              color="primary"
            />
          </>
        );
      },
    },
    {
      field: "ripubblica",
      headerName: " ",
      width: 45,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<string>) => {
        const row = params.row;
        const onClick = async () => {
          if (
            await BluAsyncDialog({
              title: "Attenzione",
              message: "Sei sicuro di voler ripubblicare il catalogo?",
              type: "warning",
            })
          ) {
            const formData = new FormData();
            formData.append("codiceGruppo", row.tipo);

            axios
              .post("/api/Global/updateQuick", formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then(() => {
                BluAsyncDialog({
                  title: "Successo",
                  message: "Catalogo ripubblicato con successo.",
                  type: "info",
                  confimButton: "Chiudi",
                  hideDeclineButton: true,
                });
              })
              .catch((err) => {
                // utile per capire cosa risponde il server
                BluAsyncDialog({
                  title: "Errore",
                  message:
                    err?.response?.data?.message ||
                    "Si è verificato un errore durante la ripubblicazione.",
                  type: "error",
                  confimButton: "Chiudi",
                  hideDeclineButton: true,
                });
              });
          }
        };

        return (
          <Tooltip title="Ripubblica catalogo nel quick">
            <IconButton color="primary" onClick={onClick}>
              <CloudSyncIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ] as GridColDef[];
};
export default columnsHandler;
